// @ts-nocheck
import { useState, useEffect } from 'react';
import jwt_decode from 'jwt-decode';
import { useCookies } from 'react-cookie';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// JSONデータ
import BoardVoice from '../../../files/board-voice.json';
import DepartmentBlogJson from '../../../files/departmentBlog.json';
import DepartmentBlogJsonTwo from '../../../files/departmentBlog202507.json';

function NewPostInHeader() {
  const baseUrl = process.env.REACT_APP_PUBLIC_URL || '';
  const [cookies] = useCookies(["sessionToken"]);
  const [cookieJti, setCookieJti] = useState();
  const [cookieEmail, setCookieEmail] = useState();
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState([]);
  const [postFlg, setPostFlg] = useState(true);

  const urlBaseBigWig = process.env.REACT_APP_WP_REST_API_PATH_BIGWIG;
  const urlBaseDepartmentBlog = process.env.REACT_APP_WP_REST_API_PATH_DEPARTMENTBLOG;

  useEffect(() => {
    if (!cookieJti) SettingLoginData();
  }, []);

  function SettingLoginData() {
    const token = cookies.sessionToken;
    const decodedToken = jwt_decode(token);
    setCookieJti(decodedToken.jti);
    setCookieEmail(decodedToken.data.EMAIL);
  }

  useEffect(() => {
    if (cookieJti) getPosts();
  }, [cookieJti]);

  async function getPosts() {
    const now = new Date();
    now.setDate(now.getDate() - 7);
    const postAfter = '&after=' + now.toISOString().split('.')[0];

    const urls = [
      {
        url: `${urlBaseBigWig}wp-json/wp/v2/posts?_fields=title,date,media_department,id${postAfter}&zenken=${cookieJti}`,
        jsonData: BoardVoice,
        blogUrlBase: '/board-voice?id=',
        jsonKey: 'catId',
      },
      {
        url: `${urlBaseDepartmentBlog}wp-json/wp/v2/posts?_fields=title,date,media_department,id,parent_info${postAfter}&zenken=${cookieJti}`,
        jsonData: DepartmentBlogJson,
        blogUrlBase: '/deptBlog?id=',
        jsonKey: 'parent',
      },
      {
        url: `${urlBaseDepartmentBlog}wp-json/wp/v2/divisionblogtwo?_fields=title,date,media_department,id,parent_info${postAfter}&zenken=${cookieJti}`,
        jsonData: DepartmentBlogJsonTwo,
        blogUrlBase: '/deptBlogTwo?id=',
        jsonKey: 'parent',
      }
    ];

    const postList = [];
    const fetchPromises = urls.map(item =>
      fetch(item.url)
        .then(res => res.json())
        .then(data => {
          data.forEach(post => {
            const termId = post.parent_info?.term_id ?? post.media_department?.id;
            const matched = item.jsonData.find(j => j[item.jsonKey] == termId);
            if (matched) {
              if (item.blogUrlBase === '/board-voice?id=') {
                post.blogTitle = item.blogUrlBase === '/board-voice?id='
                  ? 'ブログ「' + (matched.title ?? '') + '」'
                  : '';
              } else {
                post.blogTitle = '';
              }
              post.blogUrl = item.blogUrlBase + post.id + '&default=' + post.media_department?.id;
            }

            post.date = post.date.split('T')[0].replace(/-/g, '/');
            postList.push(post);
          });
        })
    );

    await Promise.all(fetchPromises);

    postList.sort((a, b) => (a.date < b.date ? 1 : -1));
    setPosts(postList);
    setPostFlg(postList.length > 0);
    setLoading(false);
  }

  useEffect(() => {
    const bv_title = document.getElementsByClassName("bv_title");
    if (bv_title.length === 0) return;

    let i = 0;
    setInterval(() => {
      i = (i + 1) % bv_title.length;
      for (let j = 0; j < bv_title.length; j++) {
        bv_title[j].classList.remove("active");
      }
      bv_title[i].classList.add("active");
    }, 7500);
  }, [posts]);

  return (
    <>
      {loading ? null : (
        postFlg && posts.map((data, index) => (
          <a
            key={data.id}
            href={baseUrl + data.blogUrl}
            className={"bv_title" + (index === 0 ? " active" : "")}
            dangerouslySetInnerHTML={{
              __html:
                (data.title.rendered + "（" + data.media_department?.name + (data.blogTitle ? data.blogTitle + "）" : "）")).length > 40
                  ? (data.title.rendered + "（" + data.media_department?.name + (data.blogTitle ? data.blogTitle + "）" : "）")).substr(0, 40) + "…"
                  : data.title.rendered + "（" + data.media_department?.name + (data.blogTitle ? data.blogTitle + "）" : "）")
            }}
          ></a>
        ))
      )}
    </>
  );
}

export default NewPostInHeader;